import React from 'react';
import FormClipboardContain from '../../../Componant/Forms/FormWidget/FormClipboard';

const Clipboard = () => {
  return (
    <div className='page-body'>
      <FormClipboardContain />
    </div>
  );
};

export default Clipboard;
